var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg18(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24L9 23V27H12V24ZM23 23L20 24V27H23V23Z",
    fill: "#FAB215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11C9 9.34315 10.3431 8 12 8H20C21.6569 8 23 9.34315 23 11V20H9V11Z",
    fill: "url(#paint0_linear_887_4810)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9117 19.7351L23 20V24H9V20L9.0883 19.7351C9.63276 18.1017 11.1613 17 12.883 17H19.117C20.8387 17 22.3672 18.1017 22.9117 19.7351Z",
    fill: "#FAB215"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 21L2 20V24H5V21Z",
    fill: "#FAB215"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 21L30 20V24H27V21Z",
    fill: "#FAB215"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0883 16.7351C2.63276 15.1017 4.16131 14 5.88304 14H9V21H2V17L2.0883 16.7351Z",
    fill: "#FAB215"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9117 16.7351C29.3672 15.1017 27.8387 14 26.117 14H23V21H30V17L29.9117 16.7351Z",
    fill: "#FAB215"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5C3.34315 5 2 6.34315 2 8V17H9V11C9 9.34315 10.3431 8 12 8H16C16 6.34315 14.6569 5 13 5H5Z",
    fill: "url(#paint1_linear_887_4810)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 5C28.6569 5 30 6.34315 30 8V17H23V11C23 9.34315 21.6569 8 20 8H16C16 6.34315 17.3431 5 19 5H27Z",
    fill: "url(#paint2_linear_887_4810)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_887_4810",
    x1: 23,
    y1: 20,
    x2: 6.94836,
    y2: 12.2485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_887_4810",
    x1: 16,
    y1: 17,
    x2: -0.0516386,
    y2: 9.24847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_887_4810",
    x1: 16,
    y1: 17,
    x2: 32.0516,
    y2: 9.24847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#FAB215",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/18.72fe5b5483e5ab2238fd05a5b2a7f233.svg";
export { ForwardRef as ReactComponent };